import { useState, useMemo, useCallback } from 'react';
import { Session as Model } from '../../api';
import api from '../../api/Schema/Api';

const checkAuthorization = async () => {
  try {
    const { data } = await Model.first();
    return data.attributes;
  } catch {
    return false;
  }
};

const useManagement = () => {
  const [message, setMessage] = useState('');
  const [pending, setPending] = useState(false);
  const clearMessage = useCallback(() => setMessage(''), []);
  const open = useCallback(async (credentials) => {
    const missingField = Object.keys(credentials).find(
      (key) => !credentials[key],
    );
    if (missingField) return setMessage(`'${missingField}' is mandatory`);

    setMessage('');
    const instance = new Model(credentials);
    setPending(true);
    try {
      const saved = await instance.save();
      setPending(false);
      return saved && instance.attributes;
    } catch (e) {
      setMessage(e.message);
      setPending(false);
      return false;
    }
  }, []);

  const management = useMemo(
    () => ({
      message,
      pending,
      clearMessage,
      open,
      close: () => {
        api.setJWT(null);
        return false;
      },
      checkAuthorization,
    }),
    [message, pending, clearMessage, open],
  );
  return management;
};

export { useManagement };
